import { render, staticRenderFns } from "./DraftSend.vue?vue&type=template&id=2042477c"
import script from "./DraftSend.vue?vue&type=script&lang=js"
export * from "./DraftSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports